var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"1000px"}},[_c('GmapMap',{staticStyle:{"height":"600px"},attrs:{"center":_vm.center,"zoom":12}},_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.center = m.position}}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }